<template>
  <div class="card shadow h-100">
    <div class="card-header bg-transparent border-0">
      <h6>Repasse</h6>
      <div class="alert alert-info">
        <h5 class="alert-heading">Bem vindo ao demonstrativo de repasse!</h5>
        <hr>
        <div v-for="(aviso) of avisoCooperado" v-bind:key="aviso.id">
          <p class="mb-0"><span class="badge badge-info"><li class="oi oi-bell"></li> {{aviso.entidade}}</span> {{aviso.descricao}} <a :href="aviso.link" target="_blank" class="alert-link" v-show="aviso.link">Clique aqui para mais informações</a></p>
        </div>
      </div>
    </div>
    <transition name="view" >
    <div class="card-body" v-show="showDashBoard">
      <div class="row">
        <div :class='classColSaldoDevedor'>
            <div class="card card-stats mb-4 mb-xl-0" style="background-color:#76CAD4">
              <div class="card-body">
                <div class="row">
                  <div class="col click_link" @click="selectedSquare('creditoMes')">
                    <h6 class="card-title text-uppercase text-muted mb-0 text-green-stronger">Crédito Mês</h6>
                    <span class="h4 font-weight-bold mb-0 text-white">{{(creditoMes != undefined && creditoMes.valor != undefined ? creditoMes.valor : 0) | formatMoney}}</span>
                  </div>
                  <div class="col-auto">
                    <button type="button" class="btn btn-sm btn-credito-mes " @click="showModal('creditoMes')">
                      <i class="oi oi-question-mark"></i>
                    </button>
                  </div>
                </div>
                <p class="mt-3 mb-0 text-muted text-sm">
                  <span :class="classLabelBadgeCreditoMes"><i :class="iconClassBadgeCreditoMes"></i>{{creditoMes != undefined && creditoMes.percentual_relacao_mes_anterior != undefined ? creditoMes.percentual_relacao_mes_anterior : 0 | formatPercent}}</span>
                  <span class="text-nowrap text-white">Desde o último mês</span>
                </p>
              </div>
            </div>
        </div>
        <div :class='classColSaldoDevedor'>
            <div class="card card-stats mb-4 mb-xl-0" style="background-color:#57BB90">
              <div class="card-body">
                <div class="row">
                  <div class="col click_link" @click="selectedSquare('ultimoCredito')">
                    <h6 class="card-title text-uppercase text-muted mb-0 text-green-stronger">ÚLTIMO CRÉDITO</h6>
                    <span class="h4 font-weight-bold mb-0 text-white">{{ultimoCredito != undefined && ultimoCredito.valor != undefined ? ultimoCredito.valor : 0 | formatMoney}}</span>
                  </div>
                  <div class="col-auto">
                    <button type="button" class="btn btn-sm btn-ultimo-credito " @click="showModal('ultimoCredito')">
                      <i class="oi oi-question-mark"></i>
                    </button>
                  </div>
                </div>
                <p class="mt-3 mb-0 text-muted text-sm">
                  <span class="badge badge-mod-success"><i class="fa fa-arrow-up"></i>{{labelBadgeUltimoCredito}}</span>
                  <span class="text-nowrap text-green-stronger"></span>
                </p>
              </div>
            </div>
        </div>
        <div :class='classColSaldoDevedor'>
          <div class="card card-stats mb-4 mb-xl-0" style="background-color:#015249">
            <div class="card-body">
              <div class="row">
                <div class="col click_link" @click="selectedSquare('rankingConvenio')">
                  <h6 class="card-title text-uppercase text-muted mb-0 text-white">Ranking Convênio Mês</h6>
                  <span class="h4 font-weight-bold mb-0 text-white">{{rankingConvenio != undefined && rankingConvenio.valor != undefined ? rankingConvenio.valor : 0 | formatMoney}}</span>
                </div>
                <div class="col-auto">
                  <button type="button" class="btn btn-sm btn-ranking-convenio" @click="showModal('rankingConvenio')">
                    <i class="oi oi-question-mark"></i>
                  </button>
                </div>
              </div>
              <p class="mt-3 mb-0 text-muted text-sm">
                <span :class="classLabelBadgeRankingConvenio"><i :class="iconClassBadgeRankingConvenio"></i>{{rankingConvenio != undefined && rankingConvenio.percentual_relacao_mes_anterior != undefined ? rankingConvenio.percentual_relacao_mes_anterior : 0 | formatPercent}}  {{rankingConvenio != undefined && rankingConvenio.convenio != undefined ? rankingConvenio.convenio : '' }}</span>
              </p>
            </div>
          </div>
        </div>
        <div :class='classColSaldoDevedor' v-show="showSquareSaldoDevedor">
            <div class="card card-stats mb-4 mb-xl-0" style="background-color:#6BBAA7">
              <div class="card-body">
                <div class="row">
                  <div class="col click_link" @click="selectedSquare('saldoDevedor')">
                    <h6 class="card-title text-uppercase text-muted mb-0 text-green-stronger">Saldo Devedor</h6>
                    <span class="h4 font-weight-bold mb-0 text-white">{{saldoDevedor != undefined && saldoDevedor.valor != undefined ? saldoDevedor.valor : 0 | formatMoney}}</span>
                  </div>
                  <div class="col-auto">
                    <button type="button" class="btn btn-sm btn-saldo-devedor" @click="showModal('saldoDevedor')">
                      <i class="oi oi-question-mark"></i>
                    </button>
                  </div>
                </div>
                <p class="mt-3 mb-0 text-muted text-sm">
                  <span :class="classLabelBadgeSaldoDevedor"><i :class="iconClassBadgeSaldoDevedor"></i>{{saldoDevedor != undefined && saldoDevedor.percentual_saldo_anterior != undefined ? saldoDevedor.percentual_saldo_anterior : 0 | formatPercent}}</span>
                  <span class="text-nowrap text-white">Desde o último saldo</span>
                </p>
              </div>
            </div>
        </div>
      </div>
      <br/>
      
      <div class="row">
        <div class="col-xl-12 col-lg-12">
          <div class="card card-stats mb-4 mb-xl-0" style="background-color:#f4fffb">
            <div class="card-body">
              <div class="row">
                <div class="col">
                  <h6 class="card-title text-uppercase text-muted mb-0 text-green-stronger">Ganhos Mensais</h6>
                  <span class="h2 font-weight-bold mb-0 text-white">
                    <apexchart type=line height=350 :options="chartOptions" :series="series" />
                  </span>
                </div>
                <div class="col-auto">
                  <div class="icon icon-shape bg-danger text-white rounded-circle shadow">
                    <i class="fas fa-chart-bar"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    </transition>
    <transition name="view">
      <div class="card-body" v-show="showCreditoMes">
        <credito-mes v-on:view-dashboard-repasse="onViewDashBoardRepasse" v-bind:objetoCabecalho="creditoMes" />
      </div>
    </transition>
    <transition name="view">
      <div class="card-body" v-show="showUltimoCredito">
        <ultimo-repasse v-on:view-dashboard-repasse="onViewDashBoardRepasse" v-bind:objetoCabecalho="ultimoCredito"/>
      </div>
    </transition>
    <transition name="view">
      <div class="card-body" v-show="showSaldoDevedor">
        <saldo-devedor v-on:view-dashboard-repasse="onViewDashBoardRepasse" v-bind:objetoCabecalho="saldoDevedor"/>
      </div>
    </transition>
    <transition name="view">
      <div class="card-body" v-show="showRankingConvenio">
        <ranking-convenio v-on:view-dashboard-repasse="onViewDashBoardRepasse" v-bind:objetoCabecalho="rankingConvenio"/>
      </div>
    </transition>
    <transition name="view">
      <div class="card-body" v-show="showCreditoMesSelecionado">
        <credito-mes-selecionado v-on:view-dashboard-repasse="onViewDashBoardRepasse" v-bind:objetoCabecalho="creditoMesSelecionado" />
      </div>
    </transition>
    <modal v-show="isModalVisible" @close="closeModal">
      <span slot="header">{{titleModal}}</span>
      <div slot="body">
        <div class="row">
          <div class="col-11">
            <span>{{textModal}}</span>
          </div>
        </div>
        
      </div>
      <div slot="footer">
      <button class="btn btn-light" @click="closeModal()">
        Fechar
      </button>
      </div>
    </modal>

  </div>
</template>

<script>
import UltimoRepasse from "./DemonstrativoRepasseUltimoRepasseDetalhado"
import CreditoMes from "./DemonstrativoRepasseCreditoMesDetalhado"
import CreditoMesSelecionado from "./DemonstrativoRepasseCreditoMesSelecionadoDetalhado"
import SaldoDevedor from "./DemonstrativoRepasseSaldoDevedorDetalhado"
import RankingConvenio from "./DemonstrativoRepasseRankingConvenioDetalhado"
import http from "./../../../../axios";
import modal from "../../../utils/Modal";
import moment from 'moment'
moment.locale('pt-BR');
export default {
  name: "DemonstrativoRepasseGraficoDetalhado",
  components: {
    "ultimo-repasse": UltimoRepasse,
    "credito-mes": CreditoMes,
    "credito-mes-selecionado": CreditoMesSelecionado,
    "saldo-devedor": SaldoDevedor,
    "ranking-convenio": RankingConvenio,
    "modal": modal
  },
  created: function() {
    this.init();
  },
  methods: {
    showModal(typeHelp) {
      if(typeHelp == "creditoMes"){
        this.titleModal = "CRÉDITO MÊS"
        this.textModal = "Soma de todos os valores líquidos do mês atual recebidos pelo(a) cooperado(a)";
      }else{
        if(typeHelp == "ultimoCredito"){
          this.titleModal = "ÚLTIMO CRÉDITO"
          this.textModal = "Valor líquido do último repasse recebido pelo(a) cooperado(a)";
        }else{
          if(typeHelp == "rankingConvenio"){
          this.titleModal = "RANKING CONVÊNIO MÊS"
            this.textModal = "Identifica os convênios que mais creditaram valores ao cooperado no mês atual.";
          }else{
            if(typeHelp == "saldoDevedor"){
              this.titleModal = "SALDO DEVEDOR"
              this.textModal = "Somatório de débitos que não foram possíveis deduzir por insuficiência de saldo";
            }
          }
        }
      }
      this.isModalVisible = true;
    },
    closeModal() {
      this.isModalVisible = false;
    },
    onViewDashBoardRepasse: function (showTemp) {
      if(showTemp){
        this.showCreditoMes = false;
        this.showCreditoMesSelecionado = false;
        this.showUltimoCredito = false;
        this.showRankingConvenio = false;
        this.showSaldoDevedor = false;
        this.showDashBoard = true;
      }
    },
    init: function() {
      this.getTokens();
      this.getDashBoardGeralRepasse();
    },
    selectedSquare: function(selected){
      if(selected == "creditoMes"){
        this.showCreditoMes = !this.showCreditoMes;
        this.showDashBoard = !this.showCreditoMes;
      }else{
        if(selected == "ultimoCredito"){
          this.showUltimoCredito = !this.showUltimoCredito;
          this.showDashBoard = !this.showUltimoCredito;
        }else{    
          if(selected == "rankingConvenio"){
            this.showRankingConvenio = !this.showRankingConvenio;
            this.showDashBoard = !this.showRankingConvenio;
          }else{
            if(selected == "saldoDevedor"){
              this.showSaldoDevedor = !this.showSaldoDevedor;
              this.showDashBoard = !this.showSaldoDevedor;
            }else{
              if(selected == "creditoMesSelecionado"){
                this.showCreditoMesSelecionado = !this.showCreditoMesSelecionado;
                this.showDashBoard = !this.showCreditoMesSelecionado;
              }
            }
          }
        }
      }

    },
    getTokens: function() {
      this.tokens = this.$cooperadowebapi.tokens.get("usuario");
    },    
    getDashBoardGeralRepasse: function() {
      this.$Progress.start();
      this.series[0].data = [];
      this.series[1].data = [];
      this.series[2].data = [];
      http
        .get(`api/repasse/dashboard/geral/${this.tokens.id}`, {
          headers: { "token-cooperado-api": this.tokens.token }
        })
        .then(r => {
          if (r.data.statusCode == 200) {
            this.ultimoCredito = r.data.result.ultimoCredito;
            this.creditoMes = r.data.result.creditoMes;
            this.saldoDevedor = r.data.result.saldoDevedor;
            this.rankingConvenio = r.data.result.rankingConvenio;
            this.avisoCooperado = r.data.result.avisoCooperado;
            
            for(var i in r.data.result.ganhosAnoAnterior){
              this.chartOptions.yaxis[0].seriesName = r.data.result.ganhosAnoAnterior[i].serie;
              this.chartOptions.yaxis[1].seriesName = r.data.result.ganhosAnoAnterior[i].serie;
              this.chartOptions.yaxis[2].seriesName = r.data.result.ganhosAnoAnterior[i].serie;
              this.series[0].name = r.data.result.ganhosAnoAnterior[i].serie;
              this.series[0].data.push(r.data.result.ganhosAnoAnterior[i].valor);
              this.series[0].percentual.push(r.data.result.ganhosAnoAnterior[i].percentual_mes_anterior);

            }
            
            for(var i in r.data.result.ganhosAnoAtual){
              this.series[1].name = r.data.result.ganhosAnoAtual[i].serie;
              this.series[1].data.push(r.data.result.ganhosAnoAtual[i].valor);
              this.series[1].percentual.push(r.data.result.ganhosAnoAtual[i].percentual_mes_anterior);
            }
            
            for(var i in r.data.result.ganhosAnoAtualMedia){
              this.series[2].name = r.data.result.ganhosAnoAtualMedia[i].serie;
              this.series[2].data.push(r.data.result.ganhosAnoAtualMedia[i].valor);
              this.series[2].percentual.push(r.data.result.ganhosAnoAtualMedia[i].percentual_mes_anterior);
            }

          } else {

          }
          this.$Progress.finish();
        })
        .catch(error => {
          this.$Progress.fail();
          if (error.response) {
            if (error.response.status >= 500) {
              this.$router.push("/");
            }
          } else if (error.request) {
            this.$router.push("/");
          } else {
            console.log("Error", error.message);
            this.$router.push("/");
          }
        });
    }
  },
  data: function() {
    return {
      showDashBoard: true,
      showCreditoMes: false ,
      showCreditoMesSelecionado : false,
      showUltimoCredito: false ,
      showRankingConvenio: false ,
      showSaldoDevedor: false ,
      showSquareSaldoDevedor: false,
      ultimoCredito: undefined,
      saldoDevedor: undefined,
      rankingConvenio: undefined,
      creditoMes: undefined,
      creditoMesSelecionado: undefined,
      isModalVisible: false,
      titleModal: "",
      textModal: "",
      avisoCooperado : [],
      tokens: {},
      series: [{
          name: '2019',
          type: 'column',
          data: [],
          percentual: []
        }, {
          name: '2020',
          type: 'column',
          data: [],
          percentual: []
        }, {
          name: 'Média 2020',
          type: 'line',
          data: [],
          percentual: []
        }],

      chartOptions: {
        colors:['#3395a1', '#ff7f50', '#ff6347'],
        chart: {
            events: {
              dataPointSelection: (event, chartContext, config) => {
                var competencia = "";
                var mesCompetencia = String(config.dataPointIndex + 1)
                if(mesCompetencia.length < 2){
                  mesCompetencia = "0" + mesCompetencia;
                }
                competencia = `${this.series[config.seriesIndex].name}-${mesCompetencia}-01`

                this.creditoMesSelecionado = {
                  mesSelecionadoText: `${this.chartOptions.xaxis.categories[config.dataPointIndex]}/${this.series[config.seriesIndex].name}`,
                  mesSelecionado: competencia,
                  valor: this.series[config.seriesIndex].data[config.dataPointIndex],
                  percentual_mes_anterior: this.series[config.seriesIndex].percentual[config.dataPointIndex]
                };

                this.selectedSquare("creditoMesSelecionado");
              }
            }
          },
          dataLabels: {
            enabled: false
          },

          stroke: {
            width: [1, 1, 4]
          },
          xaxis: {
            categories: ["Jan", "Fev", "Mar", "Abr", "Mai", "Jun", "Jul", "Ago", "Set", "Out", "Nov", "Dez"],
          },
          yaxis: [{
              seriesName: '2019',
              forceNiceScale: true,
              floating: false,
              axisTicks: {
                show: true,
              color: '#161616',
              },
              axisBorder: {
                show: true,
                color: '#161616'
              },
              labels: {
                style: {
                  color: '#161616',
                },
                
                formatter: function(value) {
                  return Vue.filter("formatMoney")(value)
                }
              },
              title: {
                style: {
                  color: '#161616',
                }
              }
            },

            {
            seriesName: '2019',
              forceNiceScale: true,
              floating: false,
              show: false,
              opposite: true,
              axisTicks: {
                show: true,
              },
              axisBorder: {
                show: true,
                color: '#161616'
              },
              labels: {
                style: {
                  color: '#161616',
                },
                
                formatter: function(value) {
                  return Vue.filter("formatMoney")(value)
                }
              },
              title: {
                style: {
                  color: '#161616',
                }
              },
            },
            {
            seriesName: '2019',
              forceNiceScale: true,
              floating: false,
              show: false,
              opposite: true,
              axisTicks: {
                show: true,
              },
              axisBorder: {
                show: true,
                color: '#161616'
              },
              labels: {
                style: {
                  color: '#161616',
                },
                
                formatter: function(value) {
                  return Vue.filter("formatMoney")(value)
                }
              },
            },
          ],
          tooltip: {
            fixed: {
              enabled: true,
              position: 'topLeft', // topRight, topLeft, bottomRight, bottomLeft
              offsetY: 30,
              offsetX: 70
            },
            marker: {
                show: true,
            },
            theme: "light",
          },
          legend: {
            horizontalAlign: 'left',
            offsetX: 40
          }
        },

        seriesDonut: [44, 55, 41, 17, 15],
        chartOptionsDonut: {
          responsive: [{
            breakpoint: 480,
            options: {
              chart: {
                width: 200
              },
              legend: {
                position: 'bottom'
              }
            }
          }]
        }
    };
  },
  
  computed: {  

    classLabelBadgeCreditoMes: function(){
      return this.creditoMes != undefined &&
             this.creditoMes.percentual_relacao_mes_anterior != undefined && 
             this.creditoMes.percentual_relacao_mes_anterior < 0 ? 
             'badge badge-mod-danger' : 'badge badge-mod-success';
    },
    iconClassBadgeCreditoMes: function(){
      return this.creditoMes != undefined && 
             this.creditoMes.percentual_relacao_mes_anterior != undefined && 
             this.creditoMes.percentual_relacao_mes_anterior < 0 ? 
             'oi oi-arrow-bottom' : 'oi oi-arrow-top';
    },
    
    classLabelBadgeRankingConvenio: function(){
      return this.rankingConvenio != undefined &&
             this.rankingConvenio.percentual_relacao_mes_anterior != undefined && 
             this.rankingConvenio.percentual_relacao_mes_anterior < 0 ? 
             'badge badge-mod-danger' : 'badge badge-mod-success';
    },
    iconClassBadgeRankingConvenio: function(){
      return this.rankingConvenio != undefined && 
             this.rankingConvenio.percentual_relacao_mes_anterior != undefined && 
             this.rankingConvenio.percentual_relacao_mes_anterior < 0 ? 
             'oi oi-arrow-bottom' : 'oi oi-arrow-top';
    },

    classLabelBadgeSaldoDevedor: function(){
      return this.saldoDevedor != undefined &&
             this.saldoDevedor.percentual_saldo_anterior != undefined && 
             this.saldoDevedor.percentual_saldo_anterior < 0 ? 
             'badge badge-mod-danger' : 'badge badge-mod-success';
    },
    classColSaldoDevedor: function(){
      this.showSquareSaldoDevedor = false;
      this.showSquareSaldoDevedor = this.saldoDevedor != undefined &&
             this.saldoDevedor.valor != undefined && 
             this.saldoDevedor.valor > 0;
      return this.showSquareSaldoDevedor ? 
             'col-xl-3 col-lg-6' : 'col-xl-4 col-lg-4';
    },
    iconClassBadgeSaldoDevedor: function(){
      return this.saldoDevedor != undefined && 
             this.saldoDevedor.percentual_saldo_anterior != undefined && 
             this.saldoDevedor.percentual_saldo_anterior < 0 ? 
             'oi oi-arrow-bottom' : 'oi oi-arrow-top';
    },

    labelBadgeUltimoCredito: function() {
      return this.ultimoCredito != undefined && this.ultimoCredito.entidade != undefined && this.ultimoCredito.repasse != undefined
        ? `${this.ultimoCredito.entidade} - Repasse ${this.ultimoCredito.repasse} - ${Vue.filter("formatDate")(
            this.ultimoCredito.competencia
          )}`
        : `Nenhum Repasse encontrado`;
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/pages/demonstrativo/repasse/DemonstrativoRepasseGraficoDetalhado.vue